import { type ParsedClaims } from '../core/context/claims';
import { type DeviceAdapter } from '../platform/device/DeviceAdapter';
import { shouldShowNewDesign } from '../core/util/shouldShowNewDesign';
import { shouldShowQrCode } from '../core/util/shouldShowQrCode';
import { calculateShouldTryFancyDeeplink } from '../core/util/shouldTryFancyDeeplink';
import rememberMe from '../lib/clients/remember-me-storage';

export type FlagName = 'redesign' | 'rememberMeEnabled' | 'showQr' | 'fancyDeeplink';

export interface FlagSources {
  claims: ParsedClaims | null;
  device: DeviceAdapter;
  hasAttemptedRedirect: boolean;
  mixpanelEnabled: boolean;
}

export interface FlagDef {
  description: string;
  resolve: (sources: FlagSources) => boolean;
}

export const FLAGS: Record<FlagName, FlagDef> = {
  redesign: {
    description: 'New design (redesign). URL ?redesign=true, else sampled on the payment id.',
    resolve: ({ claims }) => shouldShowNewDesign() || claims?.blockPhoneNumberInput === true,
  },
  rememberMeEnabled: {
    description: 'Remember-me UI + storage. Off when unsupported or ?disable-remember-me.',
    resolve: () =>
      rememberMe.isSupported() &&
      !new URLSearchParams(window.location.search).has('disable-remember-me'),
  },
  showQr: {
    description: 'QR code block. URL ?forceQr=true, else claims + device rules.',
    resolve: ({ claims, device }) => shouldShowQrCode(claims, device),
  },
  fancyDeeplink: {
    description:
      'Fancy deeplink open-in-app button. URL ?shouldTryFancyDeeplink=true, else claims + sampling.',
    resolve: ({ claims, device, hasAttemptedRedirect, mixpanelEnabled }) =>
      calculateShouldTryFancyDeeplink(claims, { hasAttemptedRedirect, mixpanelEnabled }, device),
  },
};

export const FLAG_NAMES = Object.keys(FLAGS) as FlagName[];
